import { Flex, Stepper } from '@servicetitan/anvil2';
import { WorkflowButtonsStore } from '@servicetitan/financing-workflow-shared';

export const CannotSignButtons = () => {
    const { DoneButton, CancelApplicationButton } = WorkflowButtonsStore.useStore();

    return (
        <Flex justifyContent="space-between">
            <Stepper.PrevButton label="Back" />
            <Flex gap="3" justifyContent="flex-end" grow={1}>
                <CancelApplicationButton>Cancel</CancelApplicationButton>
                <DoneButton>Done</DoneButton>
            </Flex>
        </Flex>
    );
};
